<div class="dialog-container">
  <div layout="row" layout-align="space-between center" flex>
    <span mat-dialog-title>Стартирай нова верификация</span>
    <button
      tabindex="-1"
      mat-icon-button
      class="close-button"
      [disabled]="isLoading"
      (click)="onNoClick()"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <hr />

  @if (!isLoading) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-dialog-content class="svd-content">
        <!-- Flow picker -->
        <mat-form-field appearance="outline" class="svd-flow">
          <mat-label>Метод на верификация</mat-label>
          <mat-select
            formControlName="flow"
            (selectionChange)="onFlowChange($event.value, docsPanel)"
          >
            <mat-select-trigger>
              @let currentValue = form.get('flow')?.value;
              @for (opt of FLOW_OPTIONS; track opt.value) {
                @if (opt.value === currentValue) {
                  <span class="svd-flow-option">
                    <img
                      class="svd-flow-option__logo"
                      [src]="opt.iconUrl"
                      [alt]="opt.label"
                    />
                    <span>{{ opt.label }}</span>
                  </span>
                }
              }
            </mat-select-trigger>

            @for (opt of FLOW_OPTIONS; track opt.value) {
              <mat-option [value]="opt.value">
                <span class="svd-flow-option">
                  <img
                    class="svd-flow-option__logo"
                    [src]="opt.iconUrl"
                    [alt]="opt.label"
                  />
                  <span>{{ opt.label }}</span>
                </span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Documents transfer section (INTERNAL flow only) -->
        @let isDocsTransferAvailable =
          form.get('flow')?.value === FLOW.INTERNAL;
        @let selectedSlotsCount =
          (form.get('frontId')?.value ? 1 : 0) +
          (form.get('backId')?.value ? 1 : 0) +
          (form.get('selfieId')?.value ? 1 : 0);

        <mat-expansion-panel
          #docsPanel
          class="svd-docs-expansion"
          [disabled]="!isDocsTransferAvailable"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="svd-docs-expansion__title">
              Прехвърляне на документи
                <span class="svd-docs-expansion__hint"
                  >({{ selectedSlotsCount }} от 3)</span
                >
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (loadingDocs) {
            <div class="progress-spinner-container detail-spinner">
              <mat-spinner
                class="progress-spinner"
                [diameter]="40"
              ></mat-spinner>
            </div>
          } @else {
            <div class="svd-slots">
              @for (slot of slotControls; track slot.key) {
                <div class="svd-slot">
                  <div class="svd-slot__title">{{ slot.label }}</div>

                  <div class="svd-slot__row">
                    <mat-form-field
                      appearance="outline"
                      class="svd-slot__select"
                    >
                      <mat-label>Избери документ</mat-label>
                      <mat-select
                        [formControlName]="slot.formControlName"
                      >
                        <mat-select-trigger>
                          @let selectedId =
                            form.get(slot.formControlName)?.value;
                          @for (opt of slot.options; track opt.id) {
                            @if (opt.id === selectedId) {
                              <span
                                class="svd-doc-option svd-doc-option--compact"
                              >
                                <span class="svd-doc-option__name">{{
                                  opt.name
                                }}</span>
                                @if (opt.isFromPrev) {
                                  <span
                                    class="svd-doc-option__badge svd-doc-option__badge--{{
                                      opt.stateClass
                                    }}"
                                  >
                                    {{ opt.state }}
                                  </span>
                                }
                              </span>
                            }
                          }
                        </mat-select-trigger>

                        @for (opt of slot.options; track opt.id) {
                          <mat-option [value]="opt.id">
                            <span class="svd-doc-option">
                              <mat-icon class="svd-doc-option__icon"
                                >image</mat-icon
                              >
                              <span
                                class="svd-doc-option__name"
                                itfgOverflowTooltip
                                matTooltip
                                [tooltipText]="opt.name"
                                [tooltipPosition]="'right'"
                                >{{ opt.name }}</span
                              >
                              @if (opt.isFromPrev) {
                                <span
                                  class="svd-doc-option__badge svd-doc-option__badge--{{
                                    opt.stateClass
                                  }}"
                                >
                                  {{ opt.state }}
                                </span>
                              }
                            </span>
                          </mat-option>
                        }
                      </mat-select>

                      @if (form.get(slot.formControlName)?.value) {
                        <button
                          mat-icon-button
                          type="button"
                          matSuffix
                          class="svd-slot__clear-btn"
                          [matTooltip]="'global.clear' | translate"
                          (click)="clearSlotSelection(slot, $event)"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      }

                      @if (!slot.hasOptions) {
                        <mat-hint>Няма документи от този тип</mat-hint>
                      }
                    </mat-form-field>

                    @let selectedId = form.get(slot.formControlName)?.value;
                    <button
                      mat-icon-button
                      type="button"
                      class="svd-slot__preview-btn"
                      [class.svd-slot__preview-btn--active]="
                        selectedId && previewDocId === selectedId
                      "
                      [disabled]="!selectedId"
                      [matTooltip]="'Преглед на документа'"
                      (click)="openPreview(selectedId, $event)"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      </mat-dialog-content>

      <div flex layout="row" layout-align="center center">
        <button flex type="submit" color="primary" mat-raised-button>
          Стартирай
        </button>
      </div>
    </form>
  } @else {
    <div class="progress-spinner-container detail-spinner">
      <mat-spinner
        class="progress-spinner"
        strokeWidth="10"
        [diameter]="100"
      ></mat-spinner>
    </div>
  }
</div>

<!-- ─── Overlay preview template ─── -->
<ng-template #previewTpl>
  <div class="svd-preview-popup">
    <div class="svd-preview-popup__header">
      <span
        class="svd-preview-popup__title"
        itfgOverflowTooltip
        matTooltip
        [tooltipText]="previewDocName ?? ''"
        [tooltipPosition]="'left'"
      >
        {{ previewDocName }}
      </span>
      <button mat-icon-button type="button" (click)="closePreview()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="svd-preview-popup__body">
      @if (previewLoading) {
        <div class="progress-spinner-container detail-spinner">
          <mat-spinner
            class="progress-spinner"
            strokeWidth="10"
            [diameter]="100"
          ></mat-spinner>
        </div>
      }
      @if (previewError) {
        <div class="svd-preview-popup__error">
          <mat-icon>broken_image</mat-icon>
          <span>Грешка при зареждане</span>
        </div>
      }
      @if (previewUrl && !previewLoading && !previewError) {
        <img
          class="svd-preview-popup__img"
          [src]="previewUrl"
          alt="Document preview"
        />
      }
    </div>
  </div>
</ng-template>
